module.exports = __webpack_public_path__ + "img/title-future-benefits.e199de69.svg";